jQuery(function($) {
	$(".casoteca__publicacoes").each(function () {

		new Swiper($(this).find(".swiper")[0], {
			slidesPerView: 1,
			speed: 700,
			grabCursor: true,
			loop: true,
			navigation: {
				nextEl: $(this).find(".swiper-arrow.next")[0],
				prevEl: $(this).find(".swiper-arrow.prev")[0],
			},
			mousewheel: {
				releaseOnEdges: true,
				forceToAxis: true,
			},
			breakpoints: {
				940: {
					speed: 1000,
				},
			},
		});
	});
});
